import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IApplicationContext } from 'interfaces/i-application-context-props'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { isPnStatusSigned } from 'utils/loanHelpers'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'

import './SignPn.scss'
import { useApplicationData } from 'hooks/useApplicationData'
import { LifeCycleStatus } from 'constants/enums/lifeCycleStatus'

export const SignPnLt = () => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const applicationId =
		loanApplication.applicationData?.loanNumber.toString() ||
		sessionStorage.getItem('applicationid') ||
		null

	const { applicationData } = useApplicationData(
		{ applicationId, t }
	)

	useEffect(() => {
		if (applicationData) {
			dispatchLoanApplication({
				type: LOAN_APPLICATION_ACTIONS.SET_UPDATE_APPLICATIONDATA,
				payload: applicationData,
			})
		}
	}, [applicationData, dispatchLoanApplication])

	useEffect(() => {
		const checkPnStatus = () => {
			if (isPnStatusSigned(applicationData!) || applicationData?.lifeCycleStatus === LifeCycleStatus.CollectRefinData) {
				next()
			}
			else{
				signClick()
			}
		}
		if (applicationData) {
			checkPnStatus()
		}
	}, [applicationData])

	const signClick = () => {
		const status = applicationData?.lifeCycleStatus.toLowerCase()
		if (status === 'denied' || status === 'canceled') {
			setErrorMessage(t('ApplicationRejected'))
			return
		}
		
		const url = applicationData?.signingUrls!.pnSigning?.url!
		window.location.href = url
	}

	const next = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	return (
		<div className="sign-pn lithuania">
			<div className="signing-section">
				<CircleSpinner />
				{errorMessage && (
					<div className="error-message">{errorMessage}</div>
				)}
			</div>
		</div>
	)
}
